export const enum MessageFileType {
    Image = 2,
    Video = 3,
    File = 5,
}
